export default "__VITE_ASSET__1f5b2bd5__"